var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible",
        },
      ],
      staticClass: "p-absolute top-0 right-0 bottom-0 left-0 bg-black-0-2",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "p-absolute m-auto top-0 right-0 bottom-0 left-0 p-t-25 r-2 bg-white shadow-5-g-400 z-index-3",
          staticStyle: { width: "80%", height: "80%" },
        },
        [
          _c(
            "p",
            {
              staticStyle: {
                position: "absolute",
                top: "0",
                left: "0",
                "padding-top": "5px",
                "padding-left": "10px",
                width: "100%",
                "text-align": "left",
                color: "#653EB3",
                "font-size": "14px",
              },
            },
            [_vm._v("转让群主")]
          ),
          _c("i", {
            staticClass:
              "el-icon-circle-close y-fc-999 p-absolute top-5 right-10 f-s-20 cursor-pointer",
            on: { click: _vm.close },
          }),
          _c(
            "div",
            {
              staticClass: "p-relative f-left h-100-p bg-white b-r b-c-150",
              staticStyle: { "padding-top": "51px", width: "300px" },
            },
            [
              _c("div", { staticClass: "p-absolute w-100-p top-0 left-0" }, [
                _c(
                  "div",
                  {
                    staticClass: "d-table p-x-12 w-100-p b-b b-c-g-100",
                    staticStyle: { height: "51px" },
                  },
                  [
                    _c("div", { staticClass: "d-table-cell v-a-middle" }, [
                      _c(
                        "label",
                        {
                          ref: "labelRef",
                          staticClass: "p-relative d-block h-30 bg-g-100",
                          staticStyle: { "border-radius": "15px" },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.value,
                                expression: "value",
                              },
                            ],
                            ref: "inputRef",
                            staticClass:
                              "form-element b-w-0 p-x-20 w-100-p h-30 l-h-30 bg-transparent",
                            attrs: { type: "text", placeholder: "搜索" },
                            domProps: { value: _vm.value },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.value = $event.target.value
                              },
                            },
                          }),
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.value,
                                expression: "value",
                              },
                            ],
                            staticClass:
                              "el-icon-close f-s-18 l-h-30 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.clearValue.apply(null, arguments)
                              },
                            },
                          }),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
              _c(
                "ul",
                { staticClass: "h-100-p o-auto left-personnel-box" },
                _vm._l(_vm.typeData, function (item) {
                  return _c(
                    "li",
                    {
                      key: item.account,
                      staticClass:
                        "d-table w-100-p b-b b-c-g-100 cursor-default bg-g-50-hover",
                      on: {
                        click: function ($event) {
                          return _vm.checkTurnTeamOwner(item)
                        },
                      },
                    },
                    [
                      !_vm.value ||
                      (_vm.value &&
                        ((item.nick && item.nick.includes(_vm.value)) ||
                          (item.tel && item.tel.includes(_vm.value))))
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "p-relative p-l-26 d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover",
                            },
                            [
                              item.checked
                                ? _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                      position: "absolute",
                                      top: "50%",
                                      left: "18px",
                                      transform: "translate(-50%,-50%)",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/icon_selected@2x.png"),
                                    },
                                  })
                                : _c("img", {
                                    staticStyle: {
                                      width: "20px",
                                      height: "20px",
                                      position: "absolute",
                                      top: "50%",
                                      left: "18px",
                                      transform: "translate(-50%,-50%)",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/icon_unselected@2x.png"),
                                    },
                                  }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-table-cell v-a-middle h-100-p w-64",
                                  staticStyle: { "text-align": "center" },
                                },
                                [
                                  item.account.length == 32
                                    ? _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                                          staticStyle: {
                                            "background-color": "#653EB3",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.getShortNickname(
                                                item.nick || item.tel
                                              )
                                            )
                                          ),
                                        ]
                                      )
                                    : _c("img", {
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                        },
                                        attrs: {
                                          src: require("@/assets/images/im/kefu.svg"),
                                        },
                                      }),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-table-cell v-a-middle h-100-p",
                                },
                                [
                                  _c(
                                    "div",
                                    { style: { width: _vm.listWidth + "px" } },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "t-ellipsis l-h-1-6-em m-r-10",
                                        },
                                        [_vm._v(_vm._s(item.nick))]
                                      ),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500",
                                        },
                                        [_vm._v(_vm._s(item.tel))]
                                      ),
                                      !item.nick && !item.tel
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500",
                                            },
                                            [_vm._v(_vm._s(item.account))]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _c("div", { staticClass: "h-100-p o-auto" }, [
            _c(
              "div",
              {
                staticClass: "p-relative p-x-15 p-t-25 h-100-p",
                staticStyle: { "padding-bottom": "120px" },
              },
              [
                _c(
                  "p",
                  {
                    staticClass:
                      "p-absolute top-0 left-0 p-l-15 w-100-p f-s-14",
                  },
                  [
                    _vm._v("已选择成员 "),
                    _c("span", { staticClass: "c-blue" }, [
                      _vm._v(_vm._s(_vm.checkData.nick ? 1 : 0)),
                    ]),
                    _vm._v("/1"),
                  ]
                ),
                _vm.checkData.account
                  ? _c("div", { staticClass: "h-100-p o-auto" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "p-relative p-l-26 d-table w-100-p h-67 b-b b-c-g-100 cursor-default bg-g-50-hover",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-table-cell v-a-middle h-100-p w-64",
                              staticStyle: { "text-align": "center" },
                            },
                            [
                              _vm.checkData.account.length == 32
                                ? _c(
                                    "span",
                                    {
                                      staticClass:
                                        "d-block m-auto w-40 h-40 l-h-40 t-a-center c-white rounded user-select-none",
                                      staticStyle: {
                                        "background-color": "#653EB3",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getShortNickname(
                                            _vm.checkData.nick ||
                                              _vm.checkData.tel
                                          )
                                        )
                                      ),
                                    ]
                                  )
                                : _c("img", {
                                    staticStyle: {
                                      width: "40px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: require("@/assets/images/im/kefu.svg"),
                                    },
                                  }),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "d-table-cell v-a-middle h-100-p" },
                            [
                              _c(
                                "div",
                                { style: { width: _vm.listWidth + "px" } },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "t-ellipsis l-h-1-6-em m-r-10",
                                    },
                                    [_vm._v(_vm._s(_vm.checkData.nick))]
                                  ),
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500",
                                    },
                                    [_vm._v(_vm._s(_vm.checkData.tel))]
                                  ),
                                  !_vm.checkData.nick && !_vm.checkData.tel
                                    ? _c(
                                        "p",
                                        {
                                          staticClass:
                                            "t-ellipsis l-h-1-6-em m-r-10 f-s-12 c-g-500",
                                        },
                                        [_vm._v(_vm._s(_vm.checkData.account))]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _c("i", {
                            staticClass:
                              "el-icon-close y-fc-999 h-30 f-s-18 p-absolute top-0 bottom-0 right-0 m-auto p-x-10 cursor-pointer",
                            on: {
                              click: function ($event) {
                                return _vm.deleteTeamOwner(_vm.checkData)
                              },
                            },
                          }),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "p-absolute bottom-0 left-0 w-100-p p-x-20",
                    staticStyle: { height: "60px" },
                  },
                  [
                    _c("div", { staticClass: "t-a-right p-t-10" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button m-r-10",
                          attrs: { type: "button" },
                          on: { click: _vm.close },
                        },
                        [_vm._v("取消")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "button button-blue",
                          attrs: { type: "button", disabled: _vm.disabledCp },
                          on: { click: _vm.turnTeamOwner },
                        },
                        [_vm._v("确定")]
                      ),
                    ]),
                  ]
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }